/**
 * Global live-region announcer for screen readers.
 *
 * Uses a double-rAF pattern: the first frame lets a freshly-rendered live
 * region settle into the accessibility tree; the second triggers the mutation
 * that screen readers observe. Rapid successive calls to the same region
 * (e.g. from a forEach loop) are coalesced — only the last message wins.
 * Independent live regions each maintain their own pending frames.
 *
 * Usage:
 *   window.a11yAnnounce('Item added to cart.');
 *   window.a11yAnnounce('Updating…', { busy: true });
 *   window.a11yAnnounce('Done.', { selector: '[data-form-live-region]' });
 */
window.a11yAnnounce = (function () {
  const pending = new Map();

  return function announceToLiveRegion(message, { selector = '[data-cart-live-region]', busy } = {}) {
    const liveRegion = document.querySelector(selector);
    if (!liveRegion) return;

    if (typeof busy === 'boolean') {
      liveRegion.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    if (typeof message === 'string') {
      const frames = pending.get(liveRegion) || {};
      cancelAnimationFrame(frames.outer);
      cancelAnimationFrame(frames.inner);

      liveRegion.textContent = '';
      const outer = requestAnimationFrame(() => {
        const inner = requestAnimationFrame(() => {
          liveRegion.textContent = message;
          pending.delete(liveRegion);
        });
        pending.set(liveRegion, { inner });
      });
      pending.set(liveRegion, { outer });
    }
  };
})();
